import { render, staticRenderFns } from "./pap-category.vue?vue&type=template&id=5ce85544&"
import script from "./pap-category.vue?vue&type=script&lang=js&"
export * from "./pap-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports